export const CLICK_FARM_URL = process.env.REACT_APP_CLICK_FARM_URL;
export const LOGOUT_URI = process.env.REACT_APP_LOGOUT_URI;
export const ES_APP = process.env.REACT_APP_ES_APP;
export const ES_PASSWORD = process.env.REACT_APP_ES_PASSWORD;
export const ES_URL = process.env.REACT_APP_ES_URL;
export const ES_USERNAME = process.env.REACT_APP_ES_USERNAME;
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
